import { render, staticRenderFns } from "./BookDailyPublicDateCard.vue?vue&type=template&id=13cf8105&"
import script from "./BookDailyPublicDateCard.vue?vue&type=script&lang=ts&"
export * from "./BookDailyPublicDateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports